import Sweet1 from '../../images/sweet.jpg'
import Sweet2 from '../../images/sweet-2.jpg'
import Sweet3 from '../../images/sweet-3.jpg'

export const DessertData = [
    {
        name: 'Milk Shakes',
        image: Sweet1,
    },
    {
        name: 'Doughnuts',
        image: Sweet2,
    },
    {
        name: 'Ice cream delights',
        image: Sweet3,
    },
]